import ContactFormContainer from './contact_form_container';

const ContactForm = ContactFormContainer;
export default ContactForm;
